module.exports = __webpack_public_path__ + "static/PassedAway-8459593484710046e6db68d6c3238c31.png";